import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';

// Based on
// https://github.com/unlayer/angular-email-editor/blob/master/projects/email-editor/src/lib/email-editor.component.ts
// https://docs.unlayer.com/docs/getting-started

interface UnlayerGlobal {
  createEditor(config: any): UnlayerEditor;
  loadDesign(design: object): void;
  saveDesign(callback: (data: object) => void): void;
  exportHtml(callback: (data: object) => void): void;
}

interface UnlayerEditor {
  addEventListener(event: string, handler: () => void): void;
  loadDesign(design: object): void;
  saveDesign(callback: (data: object) => void): void;
  exportHtml(callback: (data: object) => void): void;
}

export interface UnlayerOptions {
  projectId?: number;
  tools?: object;
  appearance?: object;
  locale?: string;
}

let lastEditorId = 0;

@Component({
  selector: 'app-unlayer-email-editor',
  templateUrl: './unlayer-email-editor.component.html',
  styleUrls: ['./unlayer-email-editor.component.less'],
})
export class UnlayerEmailEditorComponent implements AfterViewInit {
  @Input() editorId: string;
  @Input() options: UnlayerOptions = {};
  @Input() projectId: number;
  @Input() tools: object;
  @Input() appearance: object;
  @Input() locale: string;
  @Input() id: string;
  @Input() minHeight = '500px';

  @Output() loaded = new EventEmitter();
  @Output() ready = new EventEmitter();

  editor: any;

  constructor() {
    this.id = this.editorId || `editor-${++lastEditorId}`;
  }

  ngAfterViewInit(): void {
    this.loadEditor();
  }

  protected loadEditor() {
    const unlayerGlobal = (window as any).unlayer as UnlayerGlobal | undefined;

    if (!unlayerGlobal) {
      return;
    }

    const options: UnlayerOptions = this.options || {};

    if (this.projectId) {
      options.projectId = this.projectId;
    }

    if (this.tools) {
      options.tools = this.tools;
    }

    if (this.appearance) {
      options.appearance = this.appearance;
    }

    if (this.locale) {
      options.locale = this.locale;
    }

    this.editor = unlayerGlobal.createEditor({
      ...options,
      id: this.id,
      displayMode: 'email',
    });

    this.loaded.emit({});

    this.editor.addEventListener('editor:ready', () => {
      this.ready.emit({});
    });
  }

  public loadDesign(data: object) {
    this.editor?.loadDesign(data);
  }

  public saveDesign(cb: (data: object) => void) {
    this.editor?.saveDesign(cb);
  }

  public exportHtml(cb: (data: object) => void) {
    this.editor?.exportHtml(cb);
  }
}
